<script>
    import { Menus } from "../stores.js";

    import { flip } from 'svelte/animate';
    import { fly } from 'svelte/transition';

    let currentCategory = "All";
    let hot_menus = $Menus.filter(item => item.type === 'Hot');
    let iced_menus = $Menus.filter(item => item.type === 'Iced');

    function selectCategory(e) {
        currentCategory = e.target.innerText;
        hot_menus  = $Menus.filter(item => item.type === 'Hot'  && (currentCategory === 'All' || currentCategory === item.cate));
        iced_menus = $Menus.filter(item => item.type === 'Iced' && (currentCategory === 'All' || currentCategory === item.cate));
    }

    import SubHeader from "../components/SubHeader.svelte";
    let subHeader = {
      bg_pc: '/images/sub_menu.png',
      bg_mo: '/images/sub_menu_m.png',
      title: '커피멘토 메뉴',
      dsc: 'MENU'
    }
</script>

<SubHeader { ...subHeader } />

<section class="menu">
    <div class="menu__menu-category">
        <ul>
            <li class="{currentCategory === 'All' ? 'menu__menu-category_point' : ''}" on:click={selectCategory}> All</li>
            <li class="{currentCategory === 'Coffee' ? 'menu__menu-category_point' : ''}" on:click={selectCategory}> Coffee</li>
            <li class="{currentCategory === 'Non Coffee' ? 'menu__menu-category_point' : ''}" on:click={selectCategory}> Non Coffee</li>
        </ul>
    </div>

    <div class="menu__menu-temperature menu-temperature">
        <h4 class="menu-temperature__heading heading heading_level_4">Hot</h4>
    </div>

    <div class="menu__menu-contents menu-content">
        {#each hot_menus as menu (menu.id)}
            <div class="menu-content__menu-item" style="{'--menu-item-bg: url(\'' + menu.img + '\')'}" in:fly="{{ x: 100, duration: 300 }}"  out:fly="{{ x: -100, duration: 300 }}"  animate:flip="{{duration: 500}}">
              <div class="menu-content__menu-name">
                <p class="menu-content__menu-item_ko">{menu.ko_name}</p>
                <p class="menu-content__menu-item_en">{menu.en_name}</p>
              </div>
            </div>
        {/each}
    </div>

    <div class="menu__menu-temperature menu-temperature">
        <h4 class="menu-temperature__heading heading heading_level_4">Iced</h4>
    </div>

    <div class="menu__menu-contents menu-content">
        {#each iced_menus as menu (menu.id)}
            <div class="menu-content__menu-item" style="{'--menu-item-bg: url(\'' + menu.img + '\')'}" in:fly="{{ x: 100, duration: 300 }}"  out:fly="{{ x: -100, duration: 300 }}"  animate:flip="{{duration: 500}}">
              <div class="menu-content__menu-name">
                <p class="menu-content__menu-item_ko">{menu.ko_name}</p>
                <p class="menu-content__menu-item_en">{menu.en_name}</p>
              </div>
            </div>
        {/each}
    </div>
</section>
